import React, { useEffect, useState } from "react";
import Table from "./../../Components/Table";
import Api from "../../Hooks/Api";
import useSave from "../../Hooks/useSave";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";
import useFetchData from "../../Hooks/useFetchData";
var dateFormat = require("dateformat");
var _ = require("lodash");
const UserApproval = (props) => {
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({});
    const [Decline, setDecline] = useState(false);
    const UserRoles = useFetchData("/api/UserRoles");
    const [openApproval, setopenApproval] = useState(false);
    const [PageRole, setPageRole] = useState("User Approval");
    const url = "api/Users/PendingApproval";
    const [state, setState] = useState([]);
    const fetchData = () => {
        setState([]);
        Api.get(url)
            .then(function (response) {
                setState(response.data)
            })
            .catch(function (error) {
            })
            .then(function () {
                // always executed
            })
    };
    useEffect(() => {
        fetchData();
    }, []);

    const useValidateRole = (rolename, action) => {
        if (UserRoles.response) {
            let role = UserRoles.response.find((obj) => obj.role.name === rolename);
            if (role) {
                if (action === "AddNew") {
                    if (role.addNew) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (action === "View") {
                    if (role.view) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (action === "Edit") {
                    if (role.edit) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (action === "Export") {
                    if (role.export) {
                        return true;
                    } else {
                        return false;
                    }
                } else if (action == "Remove") {
                    if (role.remove) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    };

    const handleDecline = () => {
        if (inputs.id) {
            setOpen(false);
            setDecline(true);
            setopenApproval(true)
        } else {
            alert("Select a record to edit");
        }
    };
    const handleApprove = () => {
        if (inputs.id) {
            setOpen(false);
            setDecline(false);
            setopenApproval(true)
        } else {
            alert("Select a record to edit");
        }
    };
    const handleView = () => {
        if (inputs.id) {
            setOpen(true);
        } else {
            alert("Select a record to veiw");
        }

    };
    const handleSelect = (k, event) => {
        setInputs(k);
    };
    const handleCloseModal = () => {
        setInputs({});
        setOpen(false);
        setopenApproval(false)
    };
    const HandleSubmit = (event) => {
        event.preventDefault();
        let data = {
            UserId: inputs.id,
            Remarks: inputs.remarks,
            Action: Decline ? "Decline" : "Approve"
        }
        let approvalurl = "api/Users/approve";
        useSave(approvalurl, data);
        setTimeout(() => {
            fetchData();
        }, 2000)
    };

    const ColumnData = [
        {
            label: "UserName",
            field: "UserName",
            sort: "asc",
        },
        {
            label: "Name",
            field: "name",
            sort: "asc",
        },
        {
            label: "Mobile",
            field: "Mobile",
            sort: "asc",
        }, {
            label: "Institution",
            field: "institution",
            sort: "asc",
        },

        {
            label: "County",
            field: "county",
            sort: "asc",
        },
        {
            label: "ApprovalStatus",
            field: "approvalStatus",
            sort: "asc",
        }

    ];
    let Rowdata1 = [];
    const rows = state;

    if (rows.length > 0) {
        rows.forEach((k) => {
            const Rowdata = {
                clickEvent: () => handleSelect(k),
                UserName: k.userName,
                name: k.name,
                institution: k.institution ? k.institution.name : "N/A",
                county: k.county ? k.county.name : "N/A",
                Mobile: k.mobile,
                approvalStatus: k.approvalStatus,

            };
            Rowdata1.push(Rowdata);
        });
    }
    const ActionsBtn = (props) => {
        return (
            <div>
                {useValidateRole(props.Role, "Edit") ? (
                    <button
                        className="btn btn-primary p-2"
                        type="button"
                        onClick={handleApprove}
                    >
                        Approve
                    </button>
                ) : null}
                &nbsp; &nbsp;
                {useValidateRole(props.Role, "Edit") ? (
                    <button
                        className="btn btn-danger p-2"
                        type="button"
                        onClick={handleDecline}
                    >
                        Decline
                    </button>
                ) : null}
                &nbsp;
                <button
                    className="btn btn-warning p-2"
                    type="button"
                    onClick={handleCloseModal}
                >
                    Close
                </button>
            </div>
        );
    };

    const MoreActions = (props) => {
        return (
            <div class="col-sm-12 d-flex flex-row float-right">

                {useValidateRole(props.Role, "View") ? (
                    <button
                        onClick={handleView}
                        className="btn btn-success p-2"
                        style={{ marginRight: 5 }}
                    >
                        &nbsp; View &nbsp;
                    </button>
                ) : null}
                {useValidateRole(props.Role, "Edit") ? (
                    <button
                        onClick={handleApprove}
                        className="btn btn-info p-2"
                        style={{ marginRight: 5 }}
                    >
                        &nbsp; Approve &nbsp;
                    </button>
                ) : null}
                {useValidateRole(props.Role, "Edit") ? (
                    <button
                        onClick={handleDecline}
                        className="btn btn-danger p-2"
                        style={{ marginRight: 5 }}
                    >
                        &nbsp; Decline &nbsp;
                    </button>
                ) : null}
            </div>
        );
    };
    return (
        <div id="content" className="content">
            <ol class="breadcrumb float-xl-right">
                <li class="breadcrumb-item">
                    {" "}
                    <Link to="/">Home </Link>{" "}
                </li>
                <li class="breadcrumb-item active">Users Approval</li>
            </ol>
            <h1 class="page-header mb-3">Users Approval</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="row" style={{ margin: "5px", paddingTop: "5px" }}>
                    <MoreActions Role={PageRole} />
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <Table Rows={Rowdata1} columns={ColumnData} />
                    </div>
                </div>
            </div>
            <Modal visible={openApproval} width="65%" height="40%" effect="fadeInUp">
                <div style={{ "overflow-y": "auto", height: "100%" }}>
                    <a className="close" onClick={() => handleCloseModal()}>
                        &times;
                    </a>

                    <div className="row">
                        <div className="col-sm-5"></div>

                        <div className="col-sm-4 fontWeight-bold text-blue">
                            User Approval
                        </div>

                    </div>
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="ibox-content">
                                <br />
                                <form className="form-horizontal" onSubmit={HandleSubmit}>
                                    <div className=" row">
                                        <div className="col-sm">
                                            <div className="form-group">
                                                <label
                                                    htmlFor="Datereceived"
                                                    className="fontWeight-bold"
                                                >
                                                    {Decline ? "Decline Institution " : "Approve Institution "} Remarks
                                                </label>
                                                <textarea
                                                    type="text"
                                                    className="form-control"
                                                    name="remarks"
                                                    required
                                                    value={inputs.remarks}
                                                    onChange={handleInputChange}
                                                // defaultvalue={inputs.name}
                                                />
                                            </div>
                                        </div>

                                    </div>

                                    <div
                                        style={{ display: "flex", "justify-content": "flex-end" }}
                                    >
                                        <div class="d-flex flex-row">

                                            <button className="btn btn-primary p-2" type="submit">
                                                Submit
                                            </button>

                                            &nbsp;
                                            <button
                                                className="btn btn-warning p-2"
                                                type="button"
                                                onClick={handleCloseModal}
                                            >
                                                Close
                                            </button>
                                        </div>
                                        <br />
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal visible={open} width="70%" height="68%" effect="fadeInUp">
                <div style={{ "overflow-y": "auto", height: "100%" }}>
                    <div
                        className="row"
                        style={{
                            background: "yellow",
                            marginLeft: "10px",
                            marginRight: "10px",
                        }}
                    >
                        <div class="col-xs-12 center-block">
                            <h3 className="font-weight-bold">
                                {inputs.name}
                            </h3>
                        </div>
                    </div>

                    <div
                        className="row"
                        style={{
                            marginLeft: "10px",
                            marginRight: "10px",
                            border: "1px solid",
                        }}
                    >
                        <div className="col-sm-12" style={{ paddingTop: "2px" }}>
                            <form className="form-horizontal">
                                <div
                                    style={{ marginLeft: "10px", marginRight: "10px" }}
                                    className="row"
                                >
                                    <div className="col-sm-6">
                                        <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="font-weight-bold">Name:</td>
                                                    <td>

                                                        {inputs.name
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">SecurityGroup:</td>
                                                    <td>
                                                        {inputs.securityGroup ? (
                                                            inputs.securityGroup.name
                                                        ) : (
                                                            "N/A"
                                                        )
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Institution:</td>
                                                    <td>
                                                        {inputs.institution ? (
                                                            inputs.institution.name
                                                        ) : (
                                                            "N/A"
                                                        )
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">
                                                        County:
                                                    </td>
                                                    <td>
                                                        {inputs.type ? (
                                                            inputs.county.description
                                                        ) : (
                                                            "N/A"
                                                        )
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Active:</td>
                                                    <td>
                                                        {inputs.status ? (
                                                            "Active"
                                                        ) : (
                                                            "In-active")

                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Mobile:</td>
                                                    <td>
                                                        {inputs.mobile
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">
                                                        Email:
                                                    </td>
                                                    <td>
                                                        {inputs.email
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">
                                                        Approval Status:
                                                    </td>
                                                    <td>
                                                        {inputs.approvalStatus
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Staff REGNumber:</td>
                                                    <td>
                                                        {inputs.staff ? (
                                                            inputs.staff.REGNumber
                                                        ) : (
                                                            "N/A"
                                                        )
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Authorization Letter:</td>
                                                    <td>
                                                        <a href={process.env.REACT_APP_BASE_URL + "api/" + inputs.authorizationLetter} target="_blank"> View</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </form> <div
                                style={{
                                    display: "flex",
                                    "justify-content": "flex-end",
                                    padding: "3px",
                                }}
                            >

                                <ActionsBtn Role={PageRole} />

                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default UserApproval;
